<layout>
<div class="inset">
        <div class="horizontal">
            <div class="stack">
                <h1>{{draftConfig?.nativeName}}: {{draftConfig?.name}}</h1>
                <h3>Draft Version {{draftConfig?.version}}</h3>
                <h3>Published State: {{draftConfig?.status | titlecase}}</h3>
            </div>
            <button mat-raised-button color="primary" (click)="preview = !preview">
                <span *ngIf="preview">Edit</span>
                <span *ngIf="!preview">Preview</span>
            </button> 
        </div>
        <div *ngIf=!preview class="center">
            <!-- Config Expansion Panel -->
            <mat-expansion-panel class="expand vertical-space" *ngIf="toggle=== 'config'">
                <mat-expansion-panel-header><h4>Config</h4></mat-expansion-panel-header>
                    <mat-expansion-panel *ngFor="let item of config | keyvalue" class="expand">
                        <mat-expansion-panel-header><h4>{{item.key | titlecase}}</h4></mat-expansion-panel-header>
                        <div *ngFor="let subItem of item.value | keyvalue">
                            <div *ngIf="subItem.key !== 'lessonsCards'">
                            <mat-form-field >
                                <mat-label>{{subItem.key}}</mat-label>
                                <input matInput 
                                name={{subItem.key}}
                                type="text" 
                                (blur)="updateValue(item, subItem)"
                                [(ngModel)]="subItem.value"/>
                            </mat-form-field>
                        </div>
                        <!-- Content -->
                        <div *ngIf="subItem?.key === 'lessonsCards'">
                            <div class="lessonCardClass" *ngFor="let arrayItem of subItem.value | keyvalue" >

                                <mat-form-field >
                                    <mat-label>Lesson {{arrayItem.value.id}} Title: {{arrayItem.value.title}}</mat-label>
                                    <textarea matInput 
                                    name={{arrayItem.value.title}}
                                    type="text" 
                                    (blur)="updateLessonCard(item, subItem, arrayItem.value)"
                                    [(ngModel)]="arrayItem.value.title"></textarea>
                                </mat-form-field>
                                <mat-form-field >
                                    <mat-label>Lesson {{arrayItem.value.id}} Topic:  {{arrayItem.value.topic}}</mat-label>
                                    <textarea matInput 
                                    name={{arrayItem.value.topic}}
                                    type="text" 
                                    (blur)="updateLessonCard(item, subItem, arrayItem.value)"
                                    [(ngModel)]="arrayItem.value.topic"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-expansion-panel>
           
        </div>
        <div *ngIf="preview">
            <app-home></app-home>
        </div>

</div>
</layout>